<template>
    <form class="dml-newsletter-form" v-on:submit="enrollToNewsletter">
        <label for="NewsletterEmail"
               class="dml-newsletter-form__label"
               :class="{ 'dml-newsletter-form__label--error': error}">
            Adres e-mail
        </label>
        <input class="dml-newsletter-form__input"
               :class="{ 'dml-newsletter-form__input--error': error}"
               id="NewsletterEmail"
               name="NewsletterEmail"
               type="text"
               placeholder="Wpisz adres e-mail"
               v-model="newsletterEmail"
               v-on:blur="isEmailValid">
        <button type="submit" class="dml-newsletter-form__button">
            <span>Zapisz się</span>
        </button>
        <div class="_smut">
            <span v-if="isSuccess" class="field-validation-valid dml-validation-msg">
                Jeszcze tylko jeden krok! Na wskazany adres wysłaliśmy wiadomość, poprzez którą możesz potwierdzić swoją subskrypcję!
            </span>
            <span v-else-if="error" class="field-validation-error dml-validation-msg">
                {{error}}
            </span>
        </div>
    </form>
</template>
<script>
    const NEWSLETTER_EMAIL_REG = /^[a-zA-Z0-9_\+-]+(\.[a-zA-Z0-9_\+-]+)*@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*\.([a-zA-Z]{2,4})$/;
    export default {
        name: 'dm-newsletter-form',
        data() {
            return {
                newsletterEmail: '',
                isSuccess: false,
                error: ''
            }
        },
        methods: {
            isEmailValid() {
                if (!this.newsletterEmail) {
                    this.error = 'E-mail jest wymagany';
                    this.isSuccess = false;
                    return false;
                }
                if (!NEWSLETTER_EMAIL_REG.test(this.newsletterEmail)) {
                    this.isSuccess = false;
                    this.error = 'Podany adres e-mail jest nieprawidłowy';
                    return false;
                } 
                this.error = '';
                return true;
            },
            enrollToNewsletter(e) {
                e.preventDefault();

                if (this.isEmailValid()) {
                    this.isSuccess = false;
                    this.error = '';

                    const data = {
                        newsletterEmail: this.newsletterEmail,
                        place: 'footer'
                    };

                    DM.Service.Newsletter.enrollToNewsletter(data)
                        .then(({ error }) => {
                            if (error) {
                                this.error = error;
                            }
                            else {
                                this.isSuccess = true;
                            }
                        });
                }
            }
        }
    };
</script>
